import { render, staticRenderFns } from "./PyramidPayments.vue?vue&type=template&id=63119be4&scoped=true&"
import script from "./PyramidPayments.vue?vue&type=script&lang=js&"
export * from "./PyramidPayments.vue?vue&type=script&lang=js&"
import style0 from "./PyramidPayments.vue?vue&type=style&index=0&id=63119be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63119be4",
  null
  
)

export default component.exports